
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pam/session-recording",
      function () {
        return require("private-next-pages/pam/session-recording.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pam/session-recording"])
      });
    }
  